import React, { useEffect } from 'react';
import { useResolvedComponent } from './useResolvedComponent';
import { GenericPageShimmer } from '../shimmer/GenericPageShimmer/GenericPageShimmer';
import { RetryApiAlert } from '../shared/components/RetryApiAlert/RetryApiAlert';
import { getErrorMessageFromAxiosError } from '../request/utils';
import { resolvedComponentDataIds } from './data-ids';

export interface ResolvedComponentProps<C = unknown> {
  Component: React.FC<C>;
  componentProps?: Partial<C>;
  canActivate?: Array<() => Promise<boolean> | boolean>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolve?: { [key: string]: Promise<any> | any };
}

export function ResolvedComponent<C>({
  Component,
  componentProps,
  canActivate,
  resolve
}: ResolvedComponentProps<C>) {
  const { resolveComponent, resolvedData, resolvingRoute, canActivateRoute, routeActivationError } =
    useResolvedComponent({
      canActivate,
      resolve
    });

  useEffect(() => {
    resolveComponent();
  }, []);

  return (
    <>
      {resolvingRoute ? <GenericPageShimmer dataId={resolvedComponentDataIds.shimmer} /> : null}

      {canActivateRoute ? <Component {...resolvedData} {...componentProps} /> : null}

      {routeActivationError ? (
        <RetryApiAlert
          dataId={resolvedComponentDataIds.error}
          className='h-100'
          subTitle={getErrorMessageFromAxiosError(routeActivationError)}
          secondaryCTAProps={{
            children: 'Try Again',
            onClick: resolveComponent
          }}
        />
      ) : null}
    </>
  );
}
